import React from 'react';

import { CheckboxRounded } from '@/components/CheckboxRounded';
import RichText, { ParsedTypes } from '@/components/RichText';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

import { useOpenPredictionDocLink } from '../hooks/use-open-prediction-doc-link';

export const PredictionTncAcknowledgement = ({
    value,
    toggleValue,
    onWebViewOpened,
}: {
    value: boolean;
    toggleValue: () => void;
    onWebViewOpened?: () => void;
}) => {
    const openDocLink = useOpenPredictionDocLink(onWebViewOpened);
    const acknowledgementBody = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.richTextsSlices?.PredictionTncAcknowledgementBody
    );

    return (
        <Row
            p="s16"
            alignItems="center"
            mt="s8"
            borderRadius="r16"
            backgroundColor={ds.colorToken.background.neutral.subtler}
        >
            <Box mr="s16">
                <CheckboxRounded value={value} setValue={toggleValue} />
            </Box>
            <Box flex={1}>
                <RichText
                    data={acknowledgementBody ?? []}
                    typeProps={{
                        [ParsedTypes.P]: { color: ds.colorToken.text.secondary, textAlign: 'left' },
                        [ParsedTypes.SITE]: {
                            color: ds.colorToken.text.brand,
                            textAlign: 'left',
                            textDecorationLine: 'underline',
                            handleOnPress: openDocLink,
                        },
                    }}
                />
            </Box>
        </Row>
    );
};
